
import { NgModule, CUSTOM_ELEMENTS_SCHEMA,NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatDataGridComponent,MatDataGridDialog,MatPaginatorIntlBr }  from './mat-datagrid';
import { MaterialModule }  from '../../comum/material.module';
import {MatPaginatorIntl} from '@angular/material'
import {FormsModule} from '@angular/forms'
 
@NgModule({
    declarations: [MatDataGridComponent,MatDataGridDialog],
    imports: [ CommonModule, 
        MaterialModule,
        FlexLayoutModule, 
        FormsModule
    ],
    exports: [MatDataGridComponent,MatDataGridDialog],
    providers: [{provide : MatPaginatorIntl, useClass : MatPaginatorIntlBr }],
    entryComponents:[ MatDataGridDialog ],
    schemas:[ CUSTOM_ELEMENTS_SCHEMA,NO_ERRORS_SCHEMA ]
})
export class MatDataGridModule{};


